<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        class="pa-0"
      >
        <v-tabs
          v-model="activeSubTab"
          active-class="active-tab"
          background-color="transparent"
          height="30"
          hide-slider
          show-arrows
        >
          <v-tab
            href="#extreme-events"
          >
            {{ $t('NII.Tab.SynthesisRisk.Tab.RiskMethod1ExtremeEvent.Title') }}
          </v-tab>
          <v-tab
            href="#forward-simulations"
          >
            {{ $t('NII.Tab.SynthesisRisk.Tab.RiskMethod2ForwardSimulations.Title') }}
          </v-tab>
          <v-tab
            href="#historical-spectrum"
          >
            {{ $t('NII.Tab.SynthesisRisk.Tab.RiskMethod3HistoricalSpectrum.Title') }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="pa-0"
        cols="12"
      >
        <v-tabs-items v-model="activeSubTab">
          <v-tab-item
            value="extreme-events"
          >
            <extreme-events />
          </v-tab-item>

          <v-tab-item
            value="forward-simulations"
          >
            <forward-simulations />
          </v-tab-item>

          <v-tab-item
            value="historical-spectrum"
          >
            <historical-spectrum />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import HistoricalSpectrum       from '@/theme/default/views/banking/risk/interest-rate/NII/blocks/methodologies/HistoricalSpectrum'
import ForwardSimulations     from '@/theme/default/views/banking/risk/interest-rate/NII/blocks/methodologies/ForwardSimulations'
import ExtremeEvents      from '@/theme/default/views/banking/risk/interest-rate/NII/blocks/methodologies/ExtremeEvents'
import routerTabState       from '@/mixins/routerTabState'

export default {
  name      : 'SynthesisRiskMethodsBlock',
  components: {
    ExtremeEvents,
    ForwardSimulations,
    HistoricalSpectrum
  },
  directives: {},
  mixins    : [routerTabState],
  props     : {},
  dataStore : {
    niiAnalysisData: 'NII.FindNIIAnalysis'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {}
  },
  computed: {
    summary () {
      return this.niiAnalysisData || null
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
